import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
          <div className="text-center p-5">
            <div className="mb-4" style={{ fontSize: '3rem' }}>⚠️</div>
            <h4 className="fw-bold mb-2">Something went wrong</h4>
            <p className="text-muted mb-4">
              Try disabling browser extensions (e.g. Google Translate) and reload.
            </p>
            <button
              className="btn btn-donate px-4"
              onClick={() => window.location.reload()}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
